import { TableHead } from "../../../../common/dataClass/Default"

/**订单模块表头 */
class OrderTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

/**订单新建模块 */
class OrderNewModule{
  /**退货单表头 */
  static NEWRETURNORDERTABLEHEAD(){
    let arr = [
      new OrderTableHead('图片', 'img', '80'),
      new OrderTableHead('原所属订单编号', 'name', '100'),
      new OrderTableHead('店铺名称', 'storeName', '100'),
      new OrderTableHead('国家站点', 'countrySiteName', '80'),
      new OrderTableHead('商品标题/ASIN/MSKU', 'unitName', '300'),
      new OrderTableHead('订购时间', 'stockPrice', '100'),
      new OrderTableHead('购入价', 'getSavePriceByTable', '100'),
      new OrderTableHead('购入数量', 'getCostSummaryByTable', '100'),
      new OrderTableHead('退货数量', 'getNetProfitOfGoodsByTable', '100'),
      new OrderTableHead('退货时间', 'getCostOfCommodityInvestmentByTable', '120'),
      new OrderTableHead('退款时间', 'getCommodityCollectionByTable', '120'),
      new OrderTableHead('退货等待<br>(天)', 'getShowNumAndActualNumByTable', '120'),
      new OrderTableHead('买家退货原因', 'disposalNum', '80'),
      new OrderTableHead('库存属性', 'operate', '100'),
      new OrderTableHead('状态', 'operate', '50'),
    ]
    return arr
  }
  /**移除单表头 */
  static NEWREMOVEORDERTABLEHEAD(){
    let arr = [
      new OrderTableHead('图片', 'img', '80'),
      new OrderTableHead('商品标题/ASIN/MSKU', 'unitName', '400'),
      new OrderTableHead('店铺名称', 'storeName', '100'),
      new OrderTableHead('国家站点', 'countrySiteName', '80'),
      new OrderTableHead('原所属订单编号', 'name', '200'),
      new OrderTableHead('移除单号', 'getSavePriceByTable', '200'),
      new OrderTableHead('移除数量', 'getCostSummaryByTable', '100'),
      new OrderTableHead('移除日期', 'getNetProfitOfGoodsByTable', '100'),
      new OrderTableHead('移除原因', 'disposalNum', '400'),
    ]
    return arr
  }
  /**换货单表头 */
  static NEWSWAPORDERTABLEHEAD(){
    let arr = [
      new OrderTableHead('图片', 'img', '80'),
      new OrderTableHead('原所属订单编号', 'name', '100'),
      new OrderTableHead('店铺名称', 'storeName', '100'),
      new OrderTableHead('国家站点', 'countrySiteName', '80'),
      new OrderTableHead('商品标题/ASIN/MSKU', 'unitName', '300'),
      new OrderTableHead('原订购时间', 'stockPrice', '100'),
      new OrderTableHead('退货时间', 'getCostOfCommodityInvestmentByTable', '120'),
      new OrderTableHead('退款时间', 'getCommodityCollectionByTable', '120'),
      new OrderTableHead('退货等待<br>(天)', 'getShowNumAndActualNumByTable', '120'),
      new OrderTableHead('买家退货原因', 'disposalNum', '300'),
      new OrderTableHead('库存属性', 'operate', '100'),
      new OrderTableHead('换货订单编号', 'operate', '150'),
      new OrderTableHead('换货价', 'operate', '80'),
      new OrderTableHead('换货时间', 'operate', '100'),
    ]
    return arr
  }
  /**弃置单表头 */
  static NEWDISCARDORDERTABLEHEAD(){
    let arr = [
      new OrderTableHead('图片', 'img', '80'),
      new OrderTableHead('商品标题/ASIN/MSKU', 'unitName', '400'),
      new OrderTableHead('店铺名称', 'storeName', '100'),
      new OrderTableHead('国家站点', 'countrySiteName', '80'),
      new OrderTableHead('原所属订单编号', 'name', '200'),
      new OrderTableHead('品类', 'countrySiteName', '80'),
      new OrderTableHead('弃置单号', 'getSavePriceByTable', '200'),
      new OrderTableHead('弃置数量', 'getCostSummaryByTable', '100'),
      new OrderTableHead('弃置日期', 'getNetProfitOfGoodsByTable', '100'),
      new OrderTableHead('弃置原因', 'disposalNum', '400'),
    ]
    return arr
  }
}

export { OrderNewModule }
